<h2 mat-dialog-title>Confirm</h2>
<div mat-dialog-content>
  <p [innerHtml]="displayText"></p>
</div>
<mat-dialog-actions class="actions" align="end">
  <button class="text-white bg-gray-400 px-2 py-2 me-2" (click)="onNoClick()">No</button>
  <button class="text-white bg-green-500 px-2 py-2" (click)="onYesClick()">Yes</button>
</mat-dialog-actions>
